import React, { useEffect, useRef } from 'react';
import { useSharedCart } from '@/components/shared-cart/SharedCartProvider';
import { useUserStore } from '@/stores/userStore';

interface ScreenShareViewProps {
  stream: MediaStream;
  presenterId: string;
}

export function ScreenShareView({ stream, presenterId }: ScreenShareViewProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const { sharedCart } = useSharedCart();
  const myId = useUserStore(s => s.user?.id) || '';

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);

  const presenter =
    presenterId === myId
      ? 'You are'
      : `${
          sharedCart?.participants.find(p => p.userId === presenterId || p.guestId === presenterId)
            ?.displayName || 'A friend'
        } is`;

  return (
    <div className="overflow-hidden rounded-xl bg-ink">
      <div className="flex items-center justify-between px-4 py-2">
        <span className="text-sm text-white/70">{presenter} presenting</span>
        <span className="flex items-center gap-1.5 text-xs text-radio">
          <span className="inline-block h-2 w-2 rounded-full bg-radio" /> Live
        </span>
      </div>
      <video ref={videoRef} autoPlay playsInline muted className="max-h-[55vh] w-full bg-black" />
    </div>
  );
}
